import '../scss/module_article.scss';

import Collapse from 'bootstrap/js/dist/collapse'
import Modal from 'bootstrap/js/dist/modal'
import Dropdown from 'bootstrap/js/dist/dropdown'
import Tooltip from 'bootstrap/js/dist/tooltip'

import { initFirebaseApp } from './module_firebase';
import { manageLogin, openSignInModal } from './module_auth_helper';

import {doLast} from './module_last';
import {
    persUrl, 
    protectedApiCall, 
    sentryAPIErrorV2, 
    uam,
    funnelUpdateWhenAvailable,
    handleTryPremiumContentClick,
    attachTryPremiumSubscribe,
} from './module_common';

import { initTooltip } from './module_tooltip';

import {
    openModal,
} from './module_modal';

import {
    getFavouriteElementId,
    getCurrentAction,
    getAddAction,
    getRemoveAction,
    updateFavouriteUI,
} from './module_toggle_favourite';

import {
    configPlayer, 
    pageSetup, 
    setTocChapterPosition,
    tocRowSelector,
    tocWrapSelector,
    playerSelector,
    attachPlayerClick,
    closeMobileToc,
    attachFeedbackClick,
} from './module_player_new';

import './module_common_actions';

import {   
    sendArticleLike,
    sendArticleLikedFeedback,
    sendArticleDislikedFeedback
} from './module_api_call';

import {
    feedbackLikedModalSelector,
    feedbackDislikedModalSelector,
    initFeedback,
} from './module_feedback';

import {
    initReader,
    setReaderCurrentChapter,
    getStartChapter,
    getChaptersLength,
} from './module_cont_reader';

import {
    attachCtaActions,
} from './module_actions';

import { initNavbar } from './module_header';

const favouriteSelector = '.add-to-favourite-attach-clk';
let progressSent = false

const onChapterChange = function (currentProgress) {
    let readProgress = currentProgress
    const chaptersLength = getChaptersLength()
    
    // on switch to last chapter, send total chapter number
    if (currentProgress == (chaptersLength - 1)) readProgress = chaptersLength

    //Update API progress read
    doRemoteUpdateArticleReadProgress(readProgress)
    
    setReaderCurrentChapter(currentProgress+1)
}

const doRemoteUpdateArticleReadProgress = function (progressChapter) {
    if (aPREP) {
        const ep = persUrl(aPREP);
        if (!ep) return;
        const data = {"article_id": aCode, "chapter": parseInt(progressChapter)};
        protectedApiCall('POST', ep,
            data,
            function (resp) {
                // use for first chapter
                progressSent=true
            },
            function (err) {
                const contextData = {
                    apicalldata:{
                        function: "doRemoteUpdateArticleReadProgress",
                        url: ep,
                        method: 'POST',
                        data: JSON.stringify(data),
                        status: err.status,
                        response: err.responseJSON,
                        uid: UIDg,
                    }
                }
                const error = new Error('Error sending read progress for article')
                error.name = 'doRemoteUpdateArticleReadProgress fail'
                sentryAPIErrorV2(error, contextData)
            },
            true
        );
    }
};

function updateArticleFavourite(element) {
    const contId = getFavouriteElementId(element)
    const currentAction = getCurrentAction(element)
    const addAction = getAddAction(element)
    const removeAction = getRemoveAction(element)

    const url = uam('/users/xxx/articles/favourites/' + contId);
    
    let method = "POST";
    let newAction = 'remove';
    let funnelEvent = 'article_added_to_library';
    if (currentAction === removeAction) {
        method = "DELETE";
        newAction = addAction;
        funnelEvent = 'article_removed_from_library';
    }

    protectedApiCall(method, url, {},
        function () {
            funnelUpdate(funnelEvent);
            updateFavouriteUI(element, newAction)
        }, function (err) {
            const contextData = {
                apicalldata:{
                    function: "updateArticleFavourite",
                    url: url,
                    method: method,
                    status: err.status,
                    response: err.responseJSON,
                    uid: UIDg,
                }
            }
            const error = new Error('Error favourite for article')
            error.name = 'updateArticleFavourite fail'
            sentryAPIErrorV2(error, contextData);
        }
    );
}

const attachUpdateFavourite = function(){
    $(favouriteSelector).click(function(e){
        if (!UIDg) {
            openSignInModal()
            return
        }
        const currentTarget = $(e.currentTarget)
        updateArticleFavourite(currentTarget)
    })
}

function articleBelongsToPodcast(){
    return $(tocRowSelector).length > 0
}

function getEpisodeNum(){
    const el = $(tocWrapSelector)
    return el.data('starton')
}

const canListen = function(){
    const el = $(playerSelector)
    return el.data('audible')
}

const onPlayerClickForCantRead = function(event){
    const target = $(event.target)
    // click on Toc
    const toc = target.parents("#podcast-episodes").length
    if (toc !== 0) return
    event.stopPropagation()
    if (!UIDg){
        openSignInModal()
    }else{
        handleTryPremiumContentClick(window.location.href)
    }
}

const sendLike = async function (bid, val) {
    let funnelEvent = "";
    if (val === 1) {
        funnelEvent = "article_liked"
    } else if (val === -1) {
        funnelEvent = "article_disliked"
    }
    return sendArticleLike(bid, val)
        .then(() => {
            if (funnelEvent !== ""){
                funnelUpdate(funnelEvent);
                // datalayerBookRating(funnelEvent);
            }
            switch (val) {
                case 1:
                    openModal(feedbackLikedModalSelector, "sendLike")
                    break;
                case -1:
                    openModal(feedbackDislikedModalSelector, "sendLike")
                    break;
                default:
                    break;
            }
            return val
        })
        .catch(() => {

        })
}

const likeFeedbackPromise = function(aid, ids){
    return sendArticleLikedFeedback(aid, ids)
}

const dislikeFeedbackPromise = function(aid, ids){
    return sendArticleDislikedFeedback(aid, ids)
}

const doFirstChapterActions = function(){
    // landing on first chapter
    // send progress
    if (getStartChapter() == 0){
        let progressToSend=0
        if (getChaptersLength() == 1){
            // article with only one chapter
            progressToSend=1
        }
        manageEndOfChapterProgress(progressToSend)
    }
}

const manageEndOfChapterProgress = function(chapterProg){
    const target = document.getElementById("contentchapterend");
    function callback(entries, observer) {
        entries.forEach((entry) => {
            if(entry.isIntersecting) {
                if (progressSent) return
                doRemoteUpdateArticleReadProgress(chapterProg)
            }
        });
    }
    function createObserver(target, callback) {
        const options = {
            root: null,
            threshold: 0
        };
        const observer = new IntersectionObserver(callback, options);
        observer.observe(target);
    }
    
    createObserver(target, callback);
}

$(function () {
    initFirebaseApp()
    manageLogin()
    
    doLast();

    attachTryPremiumSubscribe()

    initTooltip()

    initNavbar();

    attachCtaActions()
    
    const canListenArticle = canListen()

    // player
    configPlayer();
    pageSetup();
    closeMobileToc()
    attachPlayerClick(canListenArticle, ()=>{}, onPlayerClickForCantRead)
    attachFeedbackClick(canListenArticle, sendLike)

    // with current progress at 1, we show "2 of XX" in the bottom of chapter
    let startChapter = getStartChapter() + 1
    // last chapter, don't add 1
    if (getChaptersLength() == getStartChapter()) startChapter = getStartChapter()
    const initReaderParams = {
        readerCurrentChapter: startChapter,
        onChapterChangeFunc: onChapterChange,
    }
    initReader(initReaderParams)

    doFirstChapterActions()

    const feedbackParams = {
        sendContentLike: likeFeedbackPromise,
        sendContentDislike: dislikeFeedbackPromise,
    }
    initFeedback(feedbackParams)

    attachUpdateFavourite()
    
    if (articleBelongsToPodcast()){
        setTocChapterPosition(getEpisodeNum())
    }
    if (!isPageReloadedAfterLogin) funnelUpdateWhenAvailable('article_viewed');
});